import { Row, Col, Card, Button, Input, Form, Spin } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { useLocation, useNavigate, useParams } from "react-router";
import apiPath from "../../constants/apiPath";
import { Link } from "react-router-dom";
import DescriptionEditor from "../../components/DescriptionEditor";

function AddEdit() {

  const sectionName   =   "CMS";
  const routeName     =   "cms";

  const { id }        =   useParams();
  const isEdit        =   Boolean(id);

  const api = {
    addEdit : apiPath.addEditCms,
    view    : apiPath.viewCms,
  };

  const location                  =   useLocation();
  const [form]                    =   Form.useForm();
  const { request }               =   useRequest();
  const [loading, setLoading]     =   useState(false);
  const [fetching, setFetching]   =   useState(false);
  const navigate                  =   useNavigate();

  const fetchData = (id) => {
    setFetching(true);
    request({
      url     : `${api.view}/${id}`,
      method  : "GET",
      onSuccess: (response) => {
        const { data }    =   response;
        form.setFieldsValue(data);
        setFetching(false);
      },
      onError: (error) => {
        setFetching(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    if (isEdit) fetchData(id);
  }, [id]);

  const onCreate = (values) => {
    setLoading(true);
    request({
      url: isEdit ? `${api.addEdit}/${id}` : api.addEdit,
      method: "POST",
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          navigate(`/${routeName}`);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: () => {
        ShowToast("Something went wrong, please try again later", Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Card title={`${isEdit ? "Edit" : "Add New"} ${sectionName}`}>
      <Spin spinning={fetching} tip="Loading CMS details...">
        <Form
          className="edit-page-wrap"
          form={form}
          layout="vertical"
          onFinish={onCreate}
          autoComplete="off"
        >
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Form.Item
                label="Title"
                name="title"
                rules={[
                  { required: true, message: "Please enter the title!" },
                  { max: 100, message: "Title should not exceed 100 characters!" },
                  { min: 2, message: "Title should be at least 2 characters!" },
                ]}
              >
                <Input placeholder="Enter Title" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Description"
                name="description"
                rules={[
                  { required: true, message: "Please enter the description!" },
                ]}
              >
                <DescriptionEditor placeholder="Enter description" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item className="btn-row float-right mt-3">
            <Link
              className="ant-btn ant-btn-secondary"
              to={`/${routeName}${location.search}`}
            >
              <i class="fas fa-arrow-left mr-5"></i> Back
            </Link>

            <Button type="primary" loading={loading} htmlType="submit">
                <i class="fas fa-check mr-5"></i>
                {isEdit ? "Update" : "Submit"}
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Card>
  );
}

export default AddEdit;
